import React, { useState, useEffect, useCallback } from "react";
import cx from "classnames";
import Link from "../../components/Link";
import ArticleCardBody from "../../components/ArticleCard/ArticleCardBody";
import SearchBar from "../../components/SearchBar";
import useDebounce from "../../hooks/useDebounce";

import "./style.scss";

const GlossaryLayout = ({ items, t }) => {
  const [currentAlphabet, setCurrentAlphabet] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearchTerm = useDebounce(searchTerm, 500);
  const [searchTermFiltered, setSearchTermFiltered] = useState(items);
  const [filterItem, setFilterItem] = useState(items);

  useEffect(() => {
    const searchTermFiltered = items.filter(
      (item) =>
        !debouncedSearchTerm ||
        (debouncedSearchTerm &&
          item.title.search(new RegExp(debouncedSearchTerm, "i")) >= 0)
    );
    const filtered = searchTermFiltered.filter(
      (item) =>
        !currentAlphabet ||
        (currentAlphabet && item.title.charAt(0) === currentAlphabet)
    );

    setSearchTermFiltered(searchTermFiltered);
    setFilterItem(filtered);
  }, [currentAlphabet, debouncedSearchTerm]);
  const onAlphabetClick = useCallback(
    (alphabet) => {
      if (currentAlphabet === alphabet) {
        setCurrentAlphabet(""); // toggle
      } else {
        setCurrentAlphabet(alphabet);
      }
    },
    [currentAlphabet, setCurrentAlphabet]
  );
  const showAlphabet = currentAlphabet !== "";
  return (
    <div className="glossary mt-md-5 py-5">
      <div className="glossary-title container d-flex justify-content-center align-items-center">
        <h1>Crypto Glossary</h1>
        <div
          className={cx(
            "current-alpha justify-content-center align-items-center text-uppercase text-white h1",
            {
              "d-flex": showAlphabet,
              "d-none": !showAlphabet,
            }
          )}
        >
          {currentAlphabet}
        </div>
      </div>
      <div className="glossary-panel pt-4 pt-md-5">
        <div className="container d-flex justify-content-center pb-4 pb-md-0">
          <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
        </div>

        <div
          id="list-alphabet-collapse"
          className="collapse show container list-alphabet mb-4 my-md-5"
        >
          <ListAlphabet
            items={searchTermFiltered}
            currentAlphabet={currentAlphabet}
            onAlphabetClick={onAlphabetClick}
          />
        </div>

        <button
          className="d-block d-md-none button button-collapse py-1 mb-4"
          type="button"
          data-toggle="collapse"
          data-target="#list-alphabet-collapse"
          aria-expanded="true"
          aria-controls="list-alphabet-collapse"
        >
          <i className="fa fa-chevron-down" />
        </button>
      </div>

      <div className="container">
        {filterItem.length || debouncedSearchTerm === "" ? (
          <div className="glossary-items row">
            <GlossaryItems items={filterItem} t={t} />
          </div>
        ) : (
          <div className="text-center my-5 mt-md-0">No available search</div>
        )}
      </div>
    </div>
  );
};

const ListAlphabet = ({ items, currentAlphabet, onAlphabetClick }) => {
  const glossaryAlphabetSet = new Set(
    items.map((item) => item.title.charAt(0))
  );

  return Array.from(Array(26)).map((_, i) => {
    const alpha = String.fromCharCode(i + 65);
    const hasGlossary = glossaryAlphabetSet.has(alpha);
    const isActive = alpha === currentAlphabet;
    return (
      <button
        className={cx("btn-alpha button m-2 text-center", {
          active: isActive,
        })}
        key={i}
        onClick={() => onAlphabetClick(alpha)}
        disabled={!hasGlossary && !isActive}
      >
        {alpha}
      </button>
    );
  });
};

const GlossaryItems = ({ items, t }) => {
  return items.map(({ title, excerpt, slug }, i) => (
    <div
      className="col-sm-6 col-lg-4 mb-4 d-flex align-items-stretch"
      key={`glossary-item-title-${i}`}
    >
      <Link className="article-card card p-1" to={`/glossary/${slug}/`}>
        <ArticleCardBody
          classNames="card-body"
          title={title}
          excerpt={excerpt}
        />
        <div className="card-footer border-0 pt-0 pb-3">
          <button
            className="button button-secondary button-rounded py-1"
            style={{ fontSize: "14px" }}
          >
            {t("common.learnMore")}
          </button>
        </div>
      </Link>
    </div>
  ));
};

export default GlossaryLayout;
